import React, { useState, useEffect } from 'react';
import { Facebook, X } from 'lucide-react';

const FacebookModal = ({ isOpen, onClose }) => {
  const [countdown, setCountdown] = useState(10);

  useEffect(() => {
    if (!isOpen) {
      setCountdown(10);
      return;
    }

    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          // Redirect to quote page
          window.location.href = 'https://cotizador.vendetucatalizador.com.mx';
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [isOpen]);

  const handleContinue = () => {
    window.location.href = 'https://cotizador.vendetucatalizador.com.mx';
  };

  const handleFollowFacebook = () => {
    window.open('https://www.facebook.com/profile.php?id=61554258313707&mibextid=ZbWKwL', '_blank');
    // Still redirect after opening Facebook
    setTimeout(() => {
      window.location.href = 'https://cotizador.vendetucatalizador.com.mx';
    }, 1000);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 sm:p-6 animate-fadeIn">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={onClose}
      />
      
      {/* Modal */}
      <div className="relative bg-gradient-to-br from-white via-blue-50 to-white rounded-2xl shadow-2xl max-w-md w-full p-6 sm:p-8 transform animate-scaleIn">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
          aria-label="Cerrar"
        >
          <X size={24} />
        </button>

        {/* Countdown Circle */}
        <div className="flex justify-center mb-6">
          <div className="relative w-24 h-24">
            {/* Animated circle background */}
            <svg className="transform -rotate-90 w-24 h-24">
              <circle
                cx="48"
                cy="48"
                r="44"
                stroke="#E5E7EB"
                strokeWidth="6"
                fill="none"
              />
              <circle
                cx="48"
                cy="48"
                r="44"
                stroke="url(#gradient)"
                strokeWidth="6"
                fill="none"
                strokeDasharray={`${(countdown / 7) * 276.46} 276.46`}
                className="transition-all duration-1000 ease-linear"
              />
              <defs>
                <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="#3B82F6" />
                  <stop offset="100%" stopColor="#1D4ED8" />
                </linearGradient>
              </defs>
            </svg>
            {/* Countdown number */}
            <div className="absolute inset-0 flex items-center justify-center">
              <span className="text-4xl font-bold bg-gradient-to-br from-blue-600 to-blue-800 bg-clip-text text-transparent">
                {countdown}
              </span>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full mb-4 shadow-lg">
            <Facebook className="text-white" size={32} />
          </div>
          
          <h2 className="text-2xl font-bold text-gray-800 mb-3">
            ¡Un momento! 🎉
          </h2>
          
          <p className="text-gray-700 mb-2 font-semibold text-base sm:text-lg">
            Para que tu cotización pueda seguir siendo gratis síguenos en Facebook
          </p>
          
          <p className="text-sm text-gray-500">
            Mantente al día con nuestras ofertas especiales y promociones exclusivas
          </p>
        </div>

        {/* CTAs */}
        <div className="space-y-3">
          <button
            onClick={handleFollowFacebook}
            className="w-full bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-semibold py-4 px-6 rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-300 flex items-center justify-center gap-2 group"
          >
            <Facebook size={20} className="group-hover:scale-110 transition-transform" />
            <span>Seguir en Facebook</span>
          </button>
          
          <button
            onClick={handleContinue}
            className="w-full bg-white hover:bg-gray-50 text-gray-700 font-semibold py-4 px-6 rounded-xl border-2 border-gray-200 hover:border-gray-300 shadow-sm hover:shadow transition-all duration-300 transform hover:-translate-y-0.5"
          >
            Continuar sin seguir
          </button>
        </div>

        {/* Auto-redirect notice */}
        <p className="text-center text-xs text-gray-400 mt-4">
          Serás redirigido automáticamente en {countdown} segundo{countdown !== 1 ? 's' : ''}
        </p>
      </div>
    </div>
  );
};

export default FacebookModal;
